import Parser from './Parser';
import encodeChars from './rules/encodeChars';
import decodeChars from './rules/decodeChars';

const capitalize = str => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

export default class TabsParser extends Parser {
  parseToUrl(data, property = false) {
    return super.parseToUrl({
      [property ? 'propertyActiveTab' : 'activeTab']: encodeChars
        .spacesDash(data.replace('Filters:', '').replace(' & ', '_'))
        .toLowerCase(),
    });
  }

  parseToData(url, isFilters, keyName = 'activeTab') {
    const data = url.split('&').map(item => item.split('='));
    const tabsValue = data.find(item => item[0] === keyName);

    if (tabsValue) {
      this.data = {
        [keyName]: `${isFilters ? 'Filters:' : ''}${decodeChars
          .spacesDash(
            tabsValue[1]
              .split('-')
              .map(str => capitalize(str))
              /* eslint-disable-next-line no-nested-ternary */
              .join('-') || (keyName === 'activeTab' ? (isFilters ? 'Location' : 'Results') : ''),
          )
          .split('_')
          .map(str => capitalize(str))
          .join('_')
          .replace('_', ' & ')}`,
      };
    }

    return this;
  }
}
